import { Injectable } from '@angular/core';
import {LoaderService} from "./loader.service";
import {ILoaderParams} from "./loader-service-impl/ILoaderParams";
import {paramsHelper} from "../helpers/params-helper";
import {E_ENDPOINTS} from "../helpers/params/loader-params";
import {ILoadChunkResult} from "../definitions";
import {SearchParams} from "../helpers/params/search-params";
import {SEARCH_PROP_TYPES} from "../enums/e-search";
import {CollectionParams} from "../helpers/params/collection-params";
import {SearchController} from "../helpers/search-controller";
import {ErrorService} from "./error.service";
import {Http} from "@angular/http";
import {PreloaderService} from "./preloader.service";

@Injectable()
export class ReportsService extends LoaderService{


  constructor(protected http: Http,
              protected errorService: ErrorService,
              protected preloaderService: PreloaderService) {
    super(http, errorService, preloaderService);
  }

  generateReport(target:string, numDays:number, apiVersion:number, metaVersion:number){

    const params = paramsHelper.loader()
      .setEndpointId(E_ENDPOINTS.LOGS)
      .setAdditionalParam("target", target)
      .setAdditionalParam("numDays", numDays)
      .setAdditionalParam("apiVersion", apiVersion)
      .setAdditionalParam("metaVersion", metaVersion);

    return this.sendPost(params.createEndpointUrl('/generateReport'), params.getBody())
      .map(r => <IStats>r.json())

  }

}

export interface IStats{
  apiVersion:number;
  metaVersion:number;
  errors:IErrorStat[];

}

export interface IErrorStat{
  command:string;
  usersAffected:string[];
  lastTimestamp:number;
}




// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/reports.service.ts